import { extractFacebookIframeSrcFromHtml } from "../../../extractor/facebook-embed-extractor";
import { CardPreviewMediaAreaRender } from "./card-preview-media-area-render";
import { Roles } from "../../../../constants/roles";
import type { DetectedLinksMap } from "../../../core/sns-detector";
import { snsPreviewManagerForm } from "../../sns-preview-manager-form";

export class FacebookCardPreviewRender {
    public static addFacebookPreviewToCard(cardElement: Element, detectedLinks: DetectedLinksMap): void {
        if (!detectedLinks.facebook?.length) return;

        const boardMediaArea = CardPreviewMediaAreaRender.findCardMediaArea(cardElement);
        if (!boardMediaArea) return;

        const existingPreview = snsPreviewManagerForm.getExistingCardPreview(cardElement, Roles.FACEBOOK_PREVIEW);
        if (existingPreview) return;

        const facebookUrl = String(detectedLinks.facebook[0]?.url || "");
        const facebookPreview = this.generateLegacyFacebookPreview(facebookUrl);
        if (!facebookPreview) return;

        const placeholder = snsPreviewManagerForm.getBoardMediaPlaceholder(boardMediaArea);
        if (placeholder) placeholder.remove();

        boardMediaArea.appendChild(facebookPreview);
    }

    public static generateLegacyFacebookPreview(facebookUrlOrContent: string): HTMLElement | null {
        if (!facebookUrlOrContent || typeof facebookUrlOrContent !== "string") {
            console.warn(
                "generateLegacyFacebookPreview: Invalid input",
                typeof facebookUrlOrContent,
                facebookUrlOrContent,
            );
            return null;
        }

        const extracted = extractFacebookIframeSrcFromHtml(facebookUrlOrContent);
        const iframeSrc = extracted
            ? extracted
            : `https://www.facebook.com/plugins/post.php?href=${encodeURIComponent(facebookUrlOrContent)}&show_text=true&width=500`;

        const previewContainer = document.createElement("div");
        previewContainer.className = "facebook-preview-container";
        previewContainer.setAttribute("data-role", Roles.FACEBOOK_PREVIEW);
        previewContainer.style.cssText = `
                position: relative;
                width: 80px;
                height: 80px;
                background: #f0f2f5;
                border-radius: 8px;
                overflow: hidden;
                border: 1px solid #e4e6ea;
            `;

        const iframe = document.createElement("iframe");
        iframe.src = iframeSrc;
        iframe.style.cssText = `
                position: absolute;
                top: 0;
                left: 0;
                width: 400px;
                height: 400px;
                border: none;
                transform: scale(0.2);
                transform-origin: 0 0;
                pointer-events: none;
            `;
        iframe.setAttribute("frameborder", "0");
        iframe.setAttribute("scrolling", "no");
        iframe.setAttribute("allowfullscreen", "true");
        iframe.setAttribute("allow", "autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share");

        previewContainer.appendChild(iframe);
        return previewContainer;
    }
}
